<svg [attr.width]="width" [attr.height]="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
        d="M19.6986 3L12.0005 10.6981L4.30138 3L3 4.30138L10.6981 12.0005L3 19.6986L4.30138 21L12.0005 13.3019L19.6986 21L21 19.6986L13.3019 12.0005L21 4.30138L19.6986 3Z"
        [attr.fill]="fill" />
</svg>
